import React from "react";
import dataFeatures from "../../../data.json";
const URL = require("../../../constants");

const Features = () => {
	return (
		<>
			<section className="pos-r o-hidden text-center">
				<div className="bg-animation">
					<img
						className="zoom-fade"
						src="images/pattern/03.png"
						alt=""
					/>
				</div>
				<div className="container wow swing">
					<div className="row">
						<div className="col-lg-8 col-md-12 ml-auto mr-auto">
							<div className="section-title">
								<div className="title-effect title-effect-2">
									<div className="ellipse"></div>{" "}
									<i className="la la-cubes"></i>
								</div>
								<h2 className="title">
									Why Choose Us as your ICT Healthcare Partner?
								</h2>
								<p>
									{
										dataFeatures.data.home[0].content
											.features.description
									}
								</p>
							</div>
						</div>
					</div>
					<div className="row">
						{dataFeatures.data.home[0].content.features.map(
							(feature, index) => (
								<div
									className="col-lg-4 col-md-6 mt-3"
									key={index}
								>
									<div className="featured-item style-2">
										<div className="featured-icon">
											<i className={feature["icon"]}></i>
										</div>
										<div className="featured-title">
											<h5 className="font-weight-bold">{feature["title"]}</h5>
										</div>
										<div className="featured-desc">
											<p className="font-weight-bold">{feature["description"]}</p>
										</div>
									</div>
								</div>
							)
						)}
					</div>
				</div>
			</section>
		</>
	);
};
export default Features;
